import {Property} from "../../../../models/Property";
import {useTranslation} from "react-i18next";
import {
  CardContent as MuiCardContent,
  Button,
  Box as MuiBox,
  Card as MuiCard,
  Typography as MuiTypography,
  CardActions,
  CardActionArea,
} from "@material-ui/core";
import {LinearProgressWithLabel} from "../../property-page-components/LinearProgressWithLabel";
import {GetIconsBasedOnClassification} from "../../PropertyListPageIcons";
import React from "react";
import styled from "styled-components/macro";
import {spacing} from "@material-ui/system";
import {RenderPropertiesProps} from "./RenderProperties";
import {useSelector} from "../../../../redux/store";
import {IUser} from "../../../../models/User";
import {getUserProfile} from "../../../../selectors";
import {getTextByCurrentLanguage} from "../../../../utils/functions";

const Box = styled(MuiBox)(spacing);
const Typography = styled(MuiTypography)(spacing)

const DayWrapper = styled.div`
    box-shadow: 0 0 16.9299px rgba(53, 64, 82, 0.05);
    border-radius: 4.83711px;
`;
const DayText = styled.div`
    background: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;

const PercentWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 20px;
`

const CompanyCell = styled.div`
  background: #a0a0a01c; 
  border-radius: 5px; 
  padding: 3px 10px
`

const Card = styled(MuiCard)(spacing);
const CardContent = styled(MuiCardContent)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

const PropertyCard = (p: Omit<RenderPropertiesProps, "properties"> & {
  item: Property
}) => {
  const { onEditFacilities, onClick, onEdit, item, companyName } = p;
  const { t } = useTranslation();
  const {
    allergy_food_class,
    allergy_room_class,
    mobility_class,
    hearing_class,
    cognitive_class,
    visual_class,
    accessibility_progress_bar: {
      all_units,
      completed_units
    },
    general_image_thumbnails
  } = item;
  const classifications = {
    allergy_food_class,
    allergy_room_class,
    mobility_class,
    hearing_class,
    cognitive_class,
    visual_class,
  }
  // used replace because this optimization for server :D
  const category = item.category.replace(/_/g, " ");
  const top_category = item.top_category.replace(/_/g, " ");
  const sub_category = item.sub_category.replace(/_/g, " ");
  const userProfile = useSelector<IUser | undefined>(getUserProfile);

  const getPercent = () => {
    if (all_units !== '0') {
      return Number(completed_units) / Number(all_units) * 100
    }
    return 0
  }

  return <Card
    style={{
      height: '100%',
      cursor: 'auto'
    }}>
    <CardActionArea>
      <CardContent style={{
        cursor: 'auto',
        minHeight: '220px',
        position: 'relative'
      }}>
        {general_image_thumbnails.medium ? (
          <img src={general_image_thumbnails.medium} alt="General Image" style={{
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            filter: 'brightness(0.3)',
            position: 'absolute'
          }}/>
        ) : null}
        <Box style={{zIndex: 1, width: '100%'}}>
          <Box mb={1}>
            <Typography variant="h4" gutterBottom display="inline" style={{ textAlign: "start", width: "100%" }}>
              {getTextByCurrentLanguage(item.name)}
            </Typography>
          </Box>
          {userProfile?.is_staff ? (
            <Box mb={2} display={'flex'}>
              <CompanyCell>
                <b>{t("signupForm_signUp_companyLabel")}:</b> {companyName}
              </CompanyCell>
            </Box>
          ) : null}
          <Typography variant="body1" gutterBottom display="inline" style={{ textAlign: "start", width: "100%", textTransform: "capitalize" }}>
            {`${top_category} | ${category} | ${sub_category}`}
          </Typography>
          <PercentWrapper>
            <LinearProgressWithLabel value={getPercent()}/>
          </PercentWrapper>
          <Typography variant="body1" gutterBottom display="inline" style={{ textAlign: "start", width: "100%" }}>
            {t("propertyListPage_disabilityClassification")}
          </Typography>
          <GetIconsBasedOnClassification classification={classifications} />
        </Box>
      </CardContent>
    </CardActionArea>
    <CardActions style={{ borderTop: "1px solid #EEEEEE", padding: "7px 0px 9px 15px", background: '#233044' }}>
      <Button size="small" color="primary" style={{ padding: "0px" }} onClick={() => onEdit(item.id)}>
        <DayWrapper>
          <DayText>
            {t("propertyListPage_editProperty")}
          </DayText>
        </DayWrapper>
      </Button>
      <Button size="small" color="primary" style={{ padding: "0px" }} onClick={() => onEditFacilities(item.id)}>
        <DayWrapper>
          <DayText>
            {t("propertyListPage_editFacilities")}
          </DayText>
        </DayWrapper>
      </Button>
      <Button size="small" color="primary" style={{ padding: "0px" }} onClick={() => onClick(item.id)}>
        <DayWrapper >
          <DayText>
            {t("questionnaire")}
          </DayText>
        </DayWrapper>
      </Button>
    </CardActions>
  </Card>
}

export default PropertyCard